module.exports = "<div class=\"lds-facebook\"><div></div><div></div><div></div></div>"